import React from 'react';
import {Card, CardContent, Typography} from "@material-ui/core";
import './InfoBox.css';


function InfoBox({ active, night, title, cases, total, ...props }) {
    return (
        <div className={night ? 'info_night' : 'info'}>
            <Card onClick ={props.onClick} className={`infoBox ${active && 'infoBox-select'} ${title === 'Cases' && 'redc'} ${title === 'Deaths' && 'notredc'}`}>
                <CardContent>
                    <Typography className="infoBox_title" color={!night ? "textSecondary" : "primary"}>
                        <strong>{title} </strong>
                    </Typography>
                    <h2 className={title+" infoBox_cases"}>+{cases}</h2>
                    <Typography className="infoBox_total" color={!night ? "textSecondary"  : "primary"}>{total} Total</Typography>
                </CardContent>
            </Card>
        </div>

    )
}

export default InfoBox

